import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataBb from './phonics/phonics_data_bb';

/**
 * Phonics Letter Bb 页面
 * 复用 PhonicsAtoZ 通用组件，只传入 Bb 数据
 */
function PhonicsBb() {
  return <PhonicsAtoZ letterData={letterDataBb} />;
}

export default PhonicsBb;
